'use strict';

$ = jQuery;

var loader = $('.jc-loader'),
    videos = $(".jc-videos"),
    pages = videos.data('pages'),
    page = 1;

loader.addClass('d-none');

window.addEventListener('scroll', function () {

  if (loader[0].classList.contains('d-none') && pages > page && isBottomVisible()) {
    loader.removeClass('d-none');
    page++;
    getVideos();
  }
});

var getVideos = function getVideos() {
  $.ajax({
    url: ajaxHandler.url,
    type: 'POST',
    data: {
      action: 'jc_ajax_get_videos',
      page: page
    },
    success: function success(response) {
      if (response && response.success) {
        videos.append(response.data.template);
        loader.addClass('d-none');
      }
    }
  });
};

var isBottomVisible = function isBottomVisible() {
  var visible = document.documentElement.clientHeight;
  var pageHeight = document.documentElement.scrollHeight - $('footer')[0].offsetHeight;
  return visible + window.scrollY >= pageHeight;
};